import { render, staticRenderFns } from "./productsCatRemove.vue?vue&type=template&id=537727f4&"
import script from "./productsCatRemove.vue?vue&type=script&lang=js&"
export * from "./productsCatRemove.vue?vue&type=script&lang=js&"
import style0 from "./productsCatRemove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports